import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "../../common/Header";
import $ from "jquery";
import useAuth from "../../../hooks/useAuth";
import DeleteItemModal from "../../../modal/DeleteItemModal";
import Toastify from "../../common/Toastify";
import { GETREQUEST } from "../../helpers/ServiceRequest";

function Products() {
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [searchItemCodeText, setSearchItemCode] = useState("");
  const [catId, setCatId] = useState("");
  const [totalPages, setTotalPages] = useState();
  const [totalItems, setTotalItems] = useState();
  const [page, setPage] = useState(0);
  const [size, setSize] = useState(100);
  const [sortColumn, setSortColumn] = useState("name");
  const [sortBy, setSortBy] = useState("ASC");
  const [currentPage, setCurrentPage] = useState();
  const [loading, setLoading] = useState(true);
  const [deletedID, setDeletedID] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');

  const { user } = useAuth();
  useEffect(() => {
    const fetchData = async () => {
      let commanURL =
        process.env.REACT_APP_API_URL + "/get-comman-all-for-product";
      let response = await GETREQUEST(commanURL, user.jwtToken, false);
      if (response?.data) {
        setCategories(response.data.categories);
      }
    }
    fetchData();
  }, []);

  useEffect(() => {
    getAllProducts();
  }, [searchText, catId, searchItemCodeText, page, size, sortColumn, sortBy]);

  const getAllProducts = async () => {
    setLoading(true);
    let URL = process.env.REACT_APP_API_URL + `/get-products?page=${page}&size=${size}`;

    const queryParams = [];
    if (catId) queryParams.push(`catId=${catId}`);
    if (searchText) queryParams.push(`searchText=${searchText}`);
    if (searchItemCodeText) queryParams.push(`searchItemCodeText=${searchItemCodeText}`);
    if (sortColumn && sortBy) queryParams.push(`sortColumn=${sortColumn}&sortBy=${sortBy}`);

    if (queryParams.length > 0) URL += `&${queryParams.join('&')}`;
    let response = await GETREQUEST(URL, user.jwtToken, false);
    if (response?.data) {
      setLoading(false);
      setProducts(response.data.data);
      setTotalPages(response.data.totalPages);
      setTotalItems(response.data.totalItems);
      setCurrentPage(response.data.currentPage);
    }
  }
  const handleSort = (sortName) => {
    setSortColumn(sortName);
    if (sortBy == "")
      setSortBy("ASC")
    else if (sortBy == "ASC")
      setSortBy("DESC")
    else
      setSortBy("ASC")
  }

  useEffect(() => {
    var headerHeight = $("header").outerHeight();
    var mainHeight = $(window).height() - headerHeight;
    $("main").height(mainHeight);
    $("main").css("margin-top", headerHeight - 20 + "px");
  });

  const getStartPageIndex = () => {
    return page === 0 ? 1 : page * size + 1;
  };

  const getEndPageIndex = () => {
    if (page === 0) {
      return products.length;
    }
    const endIndex = (page + 1) * size;
    return endIndex > totalItems ? totalItems : endIndex;
  };

  const handleDelete = async () => {
    let URL =
      process.env.REACT_APP_API_URL + "/delete-product/" + deletedID;
    setMessage('');
    setMessageType('');
    let response = await GETREQUEST(URL, user.jwtToken);
    if (response?.data) {
      setShowDeleteModal(false);
      setDeletedID(null);
      if (response.data.success) {
        setMessage(response.data.message);
        setMessageType('success');
        getAllProducts();
      } else {
        setMessage(response.data.message);
        setMessageType('error');
      }
    } else {
      setMessage(response?.error?.message || 'Failed to delete product !!');
      setMessageType('error');
    }
  }

  return (
    <React.Fragment>
      {message && <Toastify message={message} type={messageType} />}
      {showDeleteModal && <DeleteItemModal modal={showDeleteModal} handleDelete={handleDelete} setModal={setShowDeleteModal} title={'Delete Product ?'} text={"Do you want to delete this product ?"} />}
      <Header />
      <main>
        <section className="p-4 overflow-hidden table-listing">
          <div className="table-elements">
            <div className="paginations d-flex align-items-center p-2">
              <p className="fs-14 text-lite mb-1 me-2">
                Showing Results{" "}
                <span className="text-dark">{totalItems == 0 ? 0 : getStartPageIndex()}</span> -{" "}
                <span className="text-dark">{getEndPageIndex()}</span> of{" "}
                <span className="text-dark">{totalItems}</span>
              </p>
              <ul className="list-inline mb-1">
                {currentPage > 0 && (
                  <li className="list-inline-item">
                    <a style={{ cursor: "pointer" }} onClick={() => setPage(page - 1)}>
                      {" "}
                      <i className={`bi bi-chevron-left text-light`}></i>{" "}
                    </a>
                  </li>
                )}
                {totalPages > currentPage + 1 && (
                  <li className="list-inline-item">
                    <a style={{ cursor: "pointer" }} onClick={() => setPage(page + 1)}>
                      {" "}
                      <i className={`bi bi-chevron-right text-dark`}></i>{" "}
                    </a>
                  </li>
                )}
              </ul>
              <div style={{ marginLeft: "10px" }}>
                <select
                  className="form-select input-sm cme-10"
                  aria-label="Page size select example"
                  style={{ width: "100px" }}
                  value={size}
                  onChange={(e) => { setSize(e.target.value); setPage(0) }}
                >
                  <option value="50">50</option>
                  <option value="100">100</option>
                  <option value="200">200</option>
                </select>
              </div>
            </div>
          </div>
          <div className="card border-bottom-0 w-100">
            <div className="card-header bg-white d-flex align-items-center align-items-start justify-content-between cpx-20 cpy-14 sticky-top flex-nowrap overflow-auto">
              <h1 className="title-semibold fs-24 mb-0 d-flex align-items-center text-nowrap me-5 me-xl-0">
                Products
              </h1>
              <div className="filter-elements d-flex align-items-center">
                <div className="custom-group flex-nowrap">
                  <Link
                    to="/create-product"
                    className="btn btn-sm btn-secondary d-flex align-items-center text-nowrap px-3 fw-medium text-white rounded-3"
                  >
                    <i className="icon icon-add cpe-5 fs-13"></i>Add Product
                  </Link>
                </div>
              </div>
            </div>
            <div className="card-body p-0 border-bottom">
              <div className="table-responsive">
                <table className="table table-hover mb-0">
                  <thead>
                    <tr>
                      <th scope="col" className="width-lg-14 width-sm-auto">
                        <div>
                          <span style={{ cursor: "pointer" }} onClick={() => handleSort('code')}> Item Code</span>
                          {sortColumn == "code" &&
                            <span> <i className={`bi ${sortBy == "ASC" ? "bi-arrow-down-short" : "bi-arrow-up-short"}`}></i></span>
                          }
                        </div>
                        <div className="p-1">
                          <input
                            type="text"
                            className="form-control input-sm search"
                            placeholder="Search by Item Code"
                            onChange={(e) => setSearchItemCode(e.target.value)}
                          />
                        </div>
                      </th>
                      <th scope="col">
                        <div>
                          <span style={{ cursor: "pointer" }} onClick={() => handleSort('name')}>Product Name</span>
                          {sortColumn == "name" &&
                            <span> <i className={`bi ${sortBy == "ASC" ? "bi-arrow-down-short" : "bi-arrow-up-short"}`}></i></span>
                          }
                        </div>
                        <div className="w-25 p-1">
                          <input
                            type="text"
                            className="form-control input-sm search"
                            placeholder="Search by Products Name"
                            onChange={(e) => setSearchText(e.target.value)}
                          />
                        </div></th>
                      <th scope="col" className="width-lg-9 width-sm-auto">

                        <div>
                          <span style={{ cursor: "pointer" }} onClick={() => handleSort('category')}>Catagory</span>
                          {sortColumn == "status" &&
                            <span> <i className={`bi ${sortBy == "ASC" ? "bi-arrow-down-short" : "bi-arrow-up-short"}`}></i></span>
                          }
                        </div>
                        <div className="p-1">
                          <select
                            className="form-select input-sm cme-10"
                            aria-label="Default select example"
                            style={{ minWidth: "168px" }}
                            onChange={(e) => setCatId(e.target.value)}
                          >
                            <option value="">Category</option>
                            {categories.map((cat, index) => {
                              return (
                                <option value={cat.CategoryID} key={index}>
                                  {cat.CategoryName}
                                </option>
                              );
                            })}
                          </select>
                        </div>
                      </th>

                      <th scope="col" className="width-lg-5 width-sm-auto">
                        <span style={{ position: "absolute", top: "22px" }}>Action</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody className="position-relative">
                    {loading && (
                      <tr className="position-absolute w-100 ">
                        <td className="bg-white w-100 d-flex justify-content-center align-items-center p-1 border-0">
                          <div className="overlay">
                            <div
                              className="spinner-border text-primary"
                              role="status"
                            >
                              <span className="visually-hidden">
                                Loading...
                              </span>
                            </div>
                          </div>
                        </td>
                      </tr>
                    )}
                    {products.length == 0 && (
                      <tr>
                        <td colSpan={4} className="text-center">
                          No Record Found
                        </td>
                      </tr>
                    )}
                    {products &&
                      products.map((product, index) => {
                        return (
                          <tr key={index}>
                            <td>{product.ProductCode}</td>
                            <td>{product.ProductName}</td>
                            <td>
                              {product.tblProductCategoryMaps.map((item) => {
                                return `${item.tblCategory.CategoryName}, `;
                              })}
                            </td>
                            <td className="d-flex gap-2">
                              <Link
                                to={"/update-product/" + product.ProductID}
                                className="btn btn-outline-lite btn-xs d-inline-flex align-items-center text-dark"
                              >
                                View/Edit
                              </Link>
                              <button
                                onClick={() => { setShowDeleteModal(true); setDeletedID(product.ProductID) }}
                                type="button"
                                className="btn btn-outline-danger btn-xs d-inline-flex align-items-center"
                              >
                                Delete
                              </button>
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </section>
      </main>
    </React.Fragment>
  );
}

export default Products;
